// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareGroup__button_active-guTkJ";
var _3 = "scroll_up-3nM5O";
export { _1 as "__esModule", _2 as "fareGroup__button_active", _3 as "scroll_up" }
export default { "__esModule": _1, "fareGroup__button_active": _2, "scroll_up": _3 }
